import { postForm } from '@/utils/http'

let cache = null
let pending = null

/**
 * 获取轮播图列表
 */
export function getCarouselList() {
  if (cache) {
    return Promise.resolve(cache)
  }
  if (pending) {
    return pending
  }
  pending = postForm('/api/Carousel/index', {})
    .then((res) => {
      cache = res
      pending = null
      return res
    })
    .catch((err) => {
      pending = null
      throw err
    })
  return pending
}
